import { IJackpotHandler } from "./jackpot-handler/jackpot-handler.interface";
import {JACKPOT_STATE, JackpotType} from '../../../common/const/jackpot_map_ids';

export enum JackpotThemeType {
    Light,
    Dark
}

export interface IJackpotData {
    amountInCents: number;
    jackpotId: string;
    jackpotState: JACKPOT_STATE;
    lastWinAmount: number;
    mustHitTime: Date;
}

export interface IJackpotsWithStateService {
    readonly currentJackpots: Record<string, IJackpotHandler>;
    getThemeType(jpType: JackpotType): JackpotThemeType;
}
